function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_39832",
  "data-name": "Group 39832",
  transform: "translate(13801 -16032)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  width: 18,
  height: 18,
  transform: "translate(-13801 16032)",
  fill: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Layer_1",
  transform: "translate(-13804 16030)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_34582",
  "data-name": "Group 34582"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_62802",
  "data-name": "Path 62802",
  d: "M15,18.048a.952.952,0,0,1-.952.952h-8.1A.952.952,0,0,1,5,18.048V3.952A.952.952,0,0,1,5.952,3h8.1A.952.952,0,0,1,15,3.952V8h1V3.952A1.955,1.955,0,0,0,14.048,2h-8.1A1.955,1.955,0,0,0,4,3.952v14.1A1.955,1.955,0,0,0,5.952,20h8.1A1.955,1.955,0,0,0,16,18.048V14H15Z",
  fill: "#95A1B2"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_62803",
  "data-name": "Path 62803",
  d: "M19.854,10.646l-2-2-.707.707L18.293,10.5H9v1h9.293l-1.146,1.146.707.707,2-2A.5.5,0,0,0,19.854,10.646Z",
  fill: "#95A1B2"
}))));

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logout.5488a425.svg";
export { ForwardRef as ReactComponent };